export function extractQuerystringParams(): Record<string, string> {
  const doNotSend = ["returnUrl"];
  const params = parseQueryString();
  doNotSend.forEach((key) => {
    delete params[key];
  });
  return params;
}

export function parseQueryString(qs?: any): any {
  try {
    let search: string = qs || window.location.search;
    if (!search) return {};

    search = search
      .trim()
      .replace(/^(\?)/, "")
      .replace(/^(\\#)/, "");

    return JSON.parse(
      '{"' + search.replace(/&/g, '","').replace(/=/g, '":"') + '"}',
      function (key, value) {
        return key === "" ? value : decodeURIComponent(value);
      }
    );
  } catch (error) {
    return {};
  }
}
